function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M53.532 31.572c-2.226-3.808-6.946-12.794-7.327-20.17l21.488 22.05-5.83 9.234s-6.104-7.306-8.33-11.114zM118.086 37.078c2.226-3.808 6.946-12.794 7.327-20.17l-21.488 22.05 5.829 9.235s6.105-7.306 8.332-11.115z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(-1 0 0 1 80.432 87.175)",
  fill: "#D7D5EF",
  r: 80
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M152.871 120.119a29.999 29.999 0 0 0-8.048-1.074l-63.755.159c-2.52.006-5.015.489-7.356 1.421l-52.409 20.89c14.603 15.781 35.49 25.66 58.685 25.66 32.428 0 60.345-19.309 72.883-47.056z",
  fill: "#09CAC7"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 78.074,
  cy: 121.812,
  rx: 54.78,
  ry: 29.757,
  transform: "rotate(-10.657 78.074 121.812)",
  fill: "#09CAC7"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M33.136 142.655c13.174 7.843 33.785 14.976 59.58 9.433 17.192-3.693 31.356-16.222 36.791-27.567",
  stroke: "#000",
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m112.444 143.56 3.466 15.014M70.948 153.432l2.464 13.237",
  stroke: "#000"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M45.322 9.444 68.469 32.14 44.067 53.821c-1.468-3.114-6.049-12.989-6.191-21.01-.174-9.774 3.668-18.172 5.81-23.048a1.014 1.014 0 0 1 1.636-.319z",
  fill: "#000",
  stroke: "#000"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M53.828 32.335c-2.25-3.849-7.02-12.93-7.405-20.386L68.14 34.234l-5.892 9.334s-6.17-7.384-8.42-11.233z",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m38.95.669 10.176 12.198-14.68-5.858L38.95.669z",
  fill: "#000"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m128.705 16.565-25.153 19.422 21.271 23.944c1.79-2.865 7.394-11.957 8.46-19.757 1.295-9.485-1.465-18.097-2.991-23.1a1.015 1.015 0 0 0-1.587-.51z",
  fill: "#000",
  stroke: "#000"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M129.012 16.427c-1.237 7.219-5.775 15.458-8.412 18.949-2.637 3.49-9.502 9.972-9.502 9.972",
  stroke: "#000"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M118.647 37.519c2.688-3.557 8.494-12.014 9.754-19.372l-24.19 19.573 4.752 9.962s6.996-6.606 9.684-10.163z",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m135.948 8.734-11.438 10.71 15.094-4.012-3.656-6.698z",
  fill: "#000"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m57.805 111.326 3.241-26.544c8.523-.613 27.548-1.32 35.465.755 7.918 2.076 5.812 3.694 5.26 13.041l-.592 10.015-.511 8.652c-2.796 3.9-8.675 11.682-24.123 9.415-9.588-1.408-15.836-7.793-18.74-15.334z",
  fill: "#fff",
  stroke: "#000"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M125.818 75.345c-2.732 10.338-10.835 18.887-19.892 24.768-9.067 5.888-18.973 9.028-25.198 8.66-3.094-.183-6.824-1.376-10.77-3.318-3.939-1.938-8.063-4.608-11.942-7.713-7.774-6.223-14.482-14.127-16.773-21.298-4.588-14.365.794-26.335 10.167-34.585 9.394-8.267 22.761-12.756 33.985-12.093 11.207.662 22.7 6.887 30.703 15.569 8.007 8.686 12.437 19.732 9.72 30.01z",
  fill: "#fff",
  stroke: "#000"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m53.645 60-.003-.01.01-.005a30.096 30.096 0 0 1 4.744-1.483c2.945-.65 6.48-.907 9.175.472 2.695 1.378 4.556 4.395 5.752 7.164a30.082 30.082 0 0 1 1.575 4.715l.002.01a30.099 30.099 0 0 1-4.754 1.487c-2.945.65-6.48.907-9.175-.472-2.695-1.378-4.556-4.395-5.752-7.164a30.1 30.1 0 0 1-1.574-4.715z",
  fill: "#09CAC7",
  stroke: "#000"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M52.669 58.906s8.112-4.434 13.826-1.511M118.439 63.965s-7.083-5.565-14.294-3.2",
  stroke: "#000",
  strokeWidth: 3
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M68.647 59.816c4.974 3.161 9.955 22.653 9.955 22.653l12.018.71c2.729-4.7 8.886-21.54 16.315-21.101",
  stroke: "#000"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M116.638 65.902c.171-.409.301-.745.388-.982a27.988 27.988 0 0 0-4.202-1.88c-2.65-.923-5.882-1.544-8.513-.57-2.631.975-4.678 3.552-6.086 5.98a27.985 27.985 0 0 0-1.964 4.163 28.003 28.003 0 0 0 4.202 1.879c2.65.924 5.882 1.546 8.513.57 2.631-.974 4.678-3.551 6.087-5.979a28.013 28.013 0 0 0 1.575-3.18z",
  fill: "#09CAC7",
  stroke: "#000"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M84.903 91.222a1 1 0 0 1-1.57-.093l-6.12-8.796a1 1 0 0 1 .88-1.569l13.234.782a1 1 0 0 1 .689 1.662l-7.114 8.014zM60.832 65.07c-.337-4.195 1.629-7.52 1.629-7.52l2.384-.057 3.124 1.331c.112 1.398.541 4.575-.4 6.761-.94 2.187-2.433 3.904-4.183 3.503-1.079-.248-2.341-1.365-2.554-4.018zM104.133 68.065c-.434-3.62 1.154-6.565 1.154-6.565l4.893.331c.145 1.208.543 4.526-.197 6.45-.74 1.926-1.974 3.463-3.502 3.175-.943-.177-2.074-1.101-2.348-3.39z",
  fill: "#000"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M72.294 87.457c1.374 4.765 5.628 8.372 10.86 8.681 5.233.31 9.883-2.772 11.808-7.342",
  stroke: "#000",
  strokeLinecap: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m84.336 87.498-.513 8.677",
  stroke: "#000"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M66.644 47.494a1.878 1.878 0 0 1 1.62-1.649l8.493-1.119a2.933 2.933 0 1 1 .05 5.82l-8.511-.973a1.878 1.878 0 0 1-1.652-2.08zM106.813 51.126a1.878 1.878 0 0 0-1.173-1.991l-7.97-3.142a2.932 2.932 0 1 0-1.457 5.635l8.494 1.115a1.878 1.878 0 0 0 2.106-1.617z",
  fill: "#000"
});

function SvgMascot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 168,
    viewBox: "0 0 161 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascot);
export default __webpack_public_path__ + "static/media/mascot.eff467d2.svg";
export { ForwardRef as ReactComponent };